import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, Observable, Subject } from 'rxjs';

import { AccountService } from '../account.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { ConfigService } from '../../../../../core/services/config.service';

import { CommunicationService } from '../../communication/communication.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { RxComponent } from 'app/core/components/common/rx.component';
import { UtilService } from 'app/core/services/util.service';
import { SessionService } from 'app/core/services/session.service';

declare var jQuery: any;

@Component({
    selector: 'itpx-account-edit',
    templateUrl: './account-edit.component.html',
    styleUrls: ['./account-edit.component.css']
})
export class AccountEditComponent extends RxComponent implements OnInit {

    private mainFields: any[];
    private adressesFields: any[];
    private additionalFields: any[];
    private segmentsFields: any[];
    private smtpFields: any[];
    private catalogFields: any[];

    private communicationFields: any[];

    private details: any = {};
    private sub: Subscription;
    private saveUrl: string;
    private cancelRoute: string = '/agora/account-data/accounts';
    private id: string;
    private addressess: any[] = [];

    private domain: string;
    private refresh = new Subject();
    private refreshFrom = new Subject();

    private detailsCommunication: any = {};
    private codeCountryList: any = {};
    private patternList: any = {};
    private pattern: string = '.+';
    private countryCode: string;
    private accountGroupData: any[] = [];
    private countries: any = [];
    private states: any = [];
    private showStates: boolean = false;

    private hasSmtpDetails: boolean;
    private backRoute: string;
    private financeFields: any[];
    private userGroups: any;
    private form: FormGroup;
    private isCreditManager: boolean = false;

    isSeller: boolean = false;
    accountFeaturesDetailsForm: FormGroup;
    types = [{key: true, value: 'Yes'},{key: false, value: 'No'}];
    lmsCanBeEnabled: boolean;
    changeCourseEventRetailValue:boolean;
    constructor(
        private accountService: AccountService,
        private communicationService: CommunicationService,
        private configService: ConfigService,
        private notificationService: NotificationService,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private utilService: UtilService,
        private sessionService: SessionService
    ) {
        super();
    }

    ngOnInit() {
        this.userGroups = this.sessionService.getUserGroups();
        if (this.userGroups && this.userGroups.indexOf('credit-application-manager') !== -1) {
            this.isCreditManager = true;
        }
        this.buildFinanceForm(); // This is only for finance form
        this.buildAccountFeaturesDetailsForm();
        this.route.queryParams
            .map(params => params['tab'])
            .filter(tab => tab)
            .bindToLifecycle(this)
            .subscribe(tab => jQuery(`.nav-tabs a[href="#${tab}"]`).tab('show'));

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.mainFields = this.accountService.getEditMainFields();
            this.communicationFields = this.communicationService.getFields();
            this.additionalFields = this.accountService.getEditAdditionalFields();
            this.segmentsFields = this.accountService.getEditSegmentsFields();
            this.catalogFields = this.accountService.getEditCatalogDetailsFields();
            // this.smtpFields = this.accountService.getEditSmtpFields();
            //this.financeFields = this.accountService.getEditFinanceFields();

            this.accountService.getAccountDetails(this.id)
                .subscribe(
                    body => {
                        let details = <any>body['data'];
                        this.isSeller = details.seller;
                        let accGroupsObj = {};
                        let accSegments = [];
                        let accAccreditations = [];
                        let accSellerSegments = [];
                        let accComputedSegments = [];
                        let shipToAddresses = [];
                        let billToAddresses = [];
                        if (details.accountGroups && details.accountGroups.length) {
                            details.accountGroups.forEach(ag => {
                                if (ag.configType === 'account-segments-type') {
                                    accSegments.push(ag.id);
                                } else if (ag.configType === 'account-accreditations-type') {
                                    accAccreditations.push(ag.id);
                                } else if (ag.configType === 'seller-managed-segments-type') {
                                    accSellerSegments.push(ag.id);
                                } else if (ag.configType === 'computed-account-segments-type') {
                                    accComputedSegments.push(ag.id);
                                }
                            });
                        }
                        if (details.shipToAddresses && details.shipToAddresses.length) {
                            details.shipToAddresses.forEach(addr => {
                                shipToAddresses.push(addr.id);
                            });
                        }
                        if (details.shipToAddresses && details.shipToAddresses.length) {
                            details.billToAddresses.forEach(addr => {
                                billToAddresses.push(addr.id);
                            });
                        }

                        this.adressesFields = this.accountService.getEditAddressesFields(details.domains[0].name);
                        details.accountSegments = accSegments;
                        details.accountAccreditations = accAccreditations;
                        details.accountSellerSegments = accSellerSegments;
                        details.accountComputedSegments = accComputedSegments;
                        details.shipToAddresses = shipToAddresses;
                        details.billToAddresses = billToAddresses;
                        this.details = details;
                        this.domain = details.domains[0].name;
                        this.getCreditInfo(details);

                        // if ('IN' === details.country) {
                        //     this.mainFields.find(x => x.key === 'allowPayTM').type = 'checkbox';
                        // }

                        this.fetchAccountFeaturesDetails();
                    }
                );
        });
        this.communicationService.getCountries()
            .subscribe(
                body => this.countries = this.formatDict(body.data).reverse(),
            );
        this.communicationService.getPatternCodeList()
            .subscribe(
                body => this.patternList = body.data,
            );
        this.detailsCommunication.primaryAddress = false;

        this.backRoute = '/agora/account-data/accounts/' + this.id + '/details';
    }

    private buildAccountFeaturesDetailsForm() {
        this.accountFeaturesDetailsForm = this.fb.group({
            'accountFeatures.lmsEnabled.enabled': [null],
            'accountFeatures.lmsEnabled.nestedFlags.hostedExams': [null],
            'accountFeatures.lmsEnabled.nestedFlags.selfPaced': [null],
            'accountFeatures.vmsEnabled': [null],
            'accountFeatures.classes': [null],
            'accountFeatures.voucherManagement': [null],
            'accountFeatures.marketplace': [null],
            'accountFeatures.contracts': [null],
            'accountFeatures.ordersAndInvoices': [null],
            'accountFeatures.customAttributes': [null],
            'accountFeatures.externalFulfilmentEnabled': [null],
            'accountFeatures.webcamAssessments':[null],
            'accountFeatures.integration.enabled': [null],
            'accountFeatures.integration.nestedFlags.coursePublishing': [null],
            'accountFeatures.integration.nestedFlags.productPublishing': [null],
            'accountFeatures.integration.nestedFlags.supplierInvitation': [null],
            'accountFeatures.integration.nestedFlags.ssoConfiguration': [null],
            'accountFeatures.integration.nestedFlags.apiConfiguration': [null],
            'accountFeatures.integration.nestedFlags.exportAssignmentData': [null],
            'courseEventRetail': [null]          })
    }

    private getCreditInfo(details: any) {
        let currencyCode = details['currency'].configKey;
        if (currencyCode != null) {
            let accountId = details['accountId'];
            this.accountService.getCreditDetails(accountId, currencyCode).subscribe(
                body => {
                    let creditData = body.data;
                    details['creditCurrency'] = creditData.creditCurrency;
                    details['available'] = creditData.available;
                    details['used'] = creditData.used;
                    details['limit'] = creditData.limit;

                    this.bindFinanceForm(this.details);
                });
        }
    }

    private fetchAccountFeaturesDetails() {
        let domain = this.details.domains[0].name;
        this.accountService.getViltCatalogsPerDomain(domain)
            .map(_ => this.lmsCanBeEnabled = _.data && _.data.length)
            .flatMap(_ => this.accountService.fetchAccountFeaturesDetails(this.details.domains[0].name))
            .subscribe(body => {
                    this.details['features'] = body.data.features;
                    this.details['externalFulfilmentEnabled'] = this.details.features.externalFulfilmentEnabled || false;
                    this.accountFeaturesDetailsForm.patchValue( {
                    'accountFeatures.lmsEnabled.enabled': this.details.features.lmsEnabled.enabled,
                    'accountFeatures.lmsEnabled.nestedFlags.hostedExams': this.details.features.lmsEnabled.nestedFlags.hostedExams,
                    'accountFeatures.lmsEnabled.nestedFlags.selfPaced': this.details.features.lmsEnabled.nestedFlags.selfPaced,
                    'accountFeatures.vmsEnabled': this.details.features.vmsEnabled,
                    'accountFeatures.classes': this.details.features.classes,
                    'accountFeatures.voucherManagement': this.details.features.voucherManagement,
                    'accountFeatures.marketplace': this.details.features.marketplace,
                    'accountFeatures.contracts': this.details.features.contracts,
                    'accountFeatures.ordersAndInvoices': this.details.features.ordersAndInvoices,
                    'accountFeatures.customAttributes': this.details.features.customAttributes,
                    'accountFeatures.externalFulfilmentEnabled': this.details.features.externalFulfilmentEnabled,
                    'accountFeatures.webcamAssessments': this.details.features.webcamAssessments,
                    'accountFeatures.integration.enabled': this.details.features.integration.enabled,
                    'accountFeatures.integration.nestedFlags.coursePublishing': this.details.features.integration.nestedFlags.coursePublishing,
                    'accountFeatures.integration.nestedFlags.productPublishing': this.details.features.integration.nestedFlags.productPublishing,
                    'accountFeatures.integration.nestedFlags.supplierInvitation': this.details.features.integration.nestedFlags.supplierInvitation,
                    'accountFeatures.integration.nestedFlags.ssoConfiguration': this.details.features.integration.nestedFlags.ssoConfiguration,
                    'accountFeatures.integration.nestedFlags.apiConfiguration': this.details.features.integration.nestedFlags.apiConfiguration,
                    'accountFeatures.integration.nestedFlags.exportAssignmentData': this.details.features.integration.nestedFlags.exportAssignmentData,
                    'courseEventRetail': this.details.courseEventRetail
                })
                }
            );
    }

    buildFinanceForm() {
        this.form = this.fb.group({
            'currency.id': [null, Validators.required],
            creditLimitAmount: [null],
            creditLimitCurrency: [null],
            openAccount: [null],
            remainingCredit: [null],
            'paymentTerm.configValue': [null],
            levelPolicyName: [null],
            actionPolicyName: [null],
            consolidationOrdersEnabled: [null],
            consolidationOrdersFrequency: [null, Validators.required],
            billingInfo: [null],
            payTmPaymentGatewayEnabled: null
        });

        this.form.get('consolidationOrdersEnabled').valueChanges
            .bindToLifecycle(this)
            .subscribe((value: boolean) => {
                const frequencyControl: FormControl = this.form.get('consolidationOrdersFrequency') as FormControl;
                value
                    ? frequencyControl.enable()
                    : frequencyControl.disable();
            });
    }

    bindFinanceForm(details: any) {
        let currency = details.creditCurrency ? details.creditCurrency : '';
        let usedAmount = details.used ? details.used : '';
        let availableAmount = details.available ? details.available : '';
        this.form.patchValue({
            'currency.id': details.currency ? details.currency.id : null,
            creditLimitAmount: details.limit ? details.limit : 'no credit',
            openAccount: currency + ' ' + usedAmount,
            remainingCredit: currency + ' ' + availableAmount,
            creditLimitCurrency: details.creditCurrency || (details.currency ? details.currency.configKey : ''),
            'paymentTerm.configValue': details.paymentTerm ? details.paymentTerm.configValue : null,
            levelPolicyName: details.levelPolicyName,
            actionPolicyName: details.actionPolicyName,
            consolidationOrdersEnabled: details.consolidationOrdersEnabled,
            consolidationOrdersFrequency: details.consolidationOrdersFrequency || null,
            billingInfo: details.billingInfo,
            payTmPaymentGatewayEnabled: details.payTmPaymentGatewayEnabled
        });
    }

    private onSaveMain(tabDetails: any) {
        let account = Object.assign(this.details, tabDetails);
        this.manageAddresses(account)
            .bindToLifecycle(this)
            .subscribe(account => {
                this.manageSegments(account);
                delete account['domains'];

                this.edit('main', account);
            })
    }

    private onSaveCatalogDetails(catalogDetails: any) {
        catalogDetails['domain'] = this.details.domains[0].name
        this.edit('catalog', catalogDetails);
    }

    onSaveAccountFeatureForm() {
        let payload = this.accountFeaturesDetailsForm.getRawValue();
        let integrationEnabled = payload['accountFeatures.integration.enabled']
        let unFlattenForm = {};
        unFlattenForm['domain'] = this.details.domains[0].name;
        unFlattenForm['accountFeatures'] = {
            lmsEnabled: {
                enabled: payload['accountFeatures.lmsEnabled.enabled'],
                nestedFlags: {
                    hostedExams: payload['accountFeatures.lmsEnabled.nestedFlags.hostedExams'],
                    selfPaced: payload['accountFeatures.lmsEnabled.nestedFlags.selfPaced']
                }
            },
            integration: {
                enabled: payload['accountFeatures.integration.enabled'],
                nestedFlags: {
                    coursePublishing: integrationEnabled === true ? payload['accountFeatures.integration.nestedFlags.coursePublishing'] : false,
                    productPublishing: integrationEnabled === true ? payload['accountFeatures.integration.nestedFlags.productPublishing'] : false,
                    supplierInvitation : integrationEnabled === true ? payload['accountFeatures.integration.nestedFlags.supplierInvitation'] : false,
                    ssoConfiguration : integrationEnabled === true ? payload['accountFeatures.integration.nestedFlags.ssoConfiguration'] : false,
                    apiConfiguration : integrationEnabled === true ? payload['accountFeatures.integration.nestedFlags.apiConfiguration'] : false,
                    exportAssignmentData : integrationEnabled === true ? payload['accountFeatures.integration.nestedFlags.exportAssignmentData'] : false
                }
            }
        };
        unFlattenForm['accountFeatures']['vmsEnabled'] = payload['accountFeatures.vmsEnabled'];
        unFlattenForm['accountFeatures']['voucherManagement'] = payload['accountFeatures.voucherManagement'];
        unFlattenForm['accountFeatures']['marketplace'] = payload['accountFeatures.marketplace'];
        unFlattenForm['accountFeatures']['contracts'] = payload['accountFeatures.contracts'];
        unFlattenForm['accountFeatures']['ordersAndInvoices'] = payload['accountFeatures.ordersAndInvoices'];
        unFlattenForm['accountFeatures']['customAttributes'] = payload['accountFeatures.customAttributes'];
        unFlattenForm['accountFeatures']['externalFulfilmentEnabled'] = payload['accountFeatures.externalFulfilmentEnabled'];
        unFlattenForm['accountFeatures']['webcamAssessments'] = payload['accountFeatures.webcamAssessments'];
        unFlattenForm['accountFeatures']['classes'] = payload['accountFeatures.classes'];
        this.edit('accountFeatures', unFlattenForm);
        if(this.changeCourseEventRetailValue){
            delete this.details['domains'];
            delete this.details['accountAccreditations'];
            this.details['courseEventRetail'] = payload.courseEventRetail
             this.edit('main',this.details)
        }
    }
    private onSaveSellerAccount(tabDetails: any) {
        let sellerAccount = Object.assign({}, tabDetails);
        let payload = {
            id: this.details.id,
            sellerAccount: sellerAccount
        }
        payload.sellerAccount.sellerProceedsCurrency = {
            id: payload.sellerAccount.sellerProceedsCurrency
        }

        this.edit('sellerAccount', payload);
    }
    private onSaveSegments(tabDetails: any) {
        let account = tabDetails;
        let details = Object.assign({}, this.details);
        let dataToSend;

        delete details['accountSegments'];
        delete details['organizationType'];
        delete details['accountAccreditations'];
        delete details['accountSellerSegments'];
        delete details['accountComputedSegments'];

        this.manageSegments(account)
            .bindToLifecycle(this)
            .subscribe(account => {
                details['shipToAddresses'] = this.convertToArrayOfObj(details['shipToAddresses']);
                details['billToAddresses'] = this.convertToArrayOfObj(details['billToAddresses']);
                dataToSend = Object.assign(details, account);
                this.edit('segments', dataToSend);
            })
            ;
    }
    private onSaveAddress(tabDetails: any) {
        let account = tabDetails;
        let details = Object.assign({}, this.details);
        let dataToSend;

        this.manageAddresses(account)
            .bindToLifecycle(this)
            .subscribe(account => {
                this.manageSegments(account);
                delete account['domains'];

                dataToSend = Object.assign(details, account);
                delete dataToSend['accountSegments'];
                delete dataToSend['accountAccreditations'];
                delete dataToSend['accountSellerSegments'];
                delete dataToSend['accountComputedSegments'];
                this.edit('address', dataToSend);
            });
    }
    private accountGroup(accountGroups) {
        if (accountGroups && accountGroups.length) {
            this.accountGroupData = [];
            accountGroups.forEach(ag => {
                this.accountGroupData.push({
                    id: ag
                });
            });
        }
    }
    private onPhoneNumbersChange(phoneNumbers: any[]) {
        this.detailsCommunication.phoneNumbers = phoneNumbers;
    }
    private convertToArrayOfObj(arr) {
        let result = [];
        arr.forEach(el => {
            let item = typeof el === 'string' ? { id: el } : el
            result.push(item);
        });

        return result;
    }

    private onSaveFinance() {
        let finance = this.form.value;
        let unFlattenFinance = this.utilService.unflatten(finance);
        let details = Object.assign({}, this.details);
        let dataToSend;

        this.manageAddresses(unFlattenFinance)
            .bindToLifecycle(this)
            .subscribe(finance => {
                this.manageFinance(unFlattenFinance);
                dataToSend = Object.assign(details, unFlattenFinance);
                delete dataToSend['accountSegments'];
                delete dataToSend['accountAccreditations'];
                delete dataToSend['accountSellerSegments'];
                delete dataToSend['accountComputedSegments'];
                delete dataToSend['creditLimitAmount'];
                delete dataToSend['openAccount'];
                delete dataToSend['remainingCredit'];

                this.edit('finance', dataToSend);
            });
    }

    private manageFinance(finance: any): Observable<any> {
        finance['accountGroups'] = [];
        finance['smtpDetails'] = [];
        finance['taxData'] = [];

        return Observable.of(finance);
    }

    private manageSegments(account: any): Observable<any> {
        account['accountSegments'] = account['accountSegments'] || [];
        account['accountAccreditations'] = account['accountAccreditations'] || [];
        account['accountSellerSegments'] = account['accountSellerSegments'] || [];
        account['accountComputedSegments'] = account['accountComputedSegments'] || [];

        let accountGroups = account['accountSegments'].concat(account['accountAccreditations'], account['accountSellerSegments'], account['accountComputedSegments']);

        this.accountGroup(accountGroups);

        if (this.accountGroupData.length) {
            account['accountGroups'] = this.accountGroupData;
        }

        delete account['accountSegments'];
        delete account['accountAccreditations'];
        delete account['accountSellerSegments'];
        delete account['accountComputedSegments'];

        return Observable.of(account);
    }
    private manageAddresses(account: any): Observable<any> {
        account['shipToAddresses'] = account['shipToAddresses'] || [];
        account['billToAddresses'] = account['billToAddresses'] || [];

        account['shipToAddresses'] = this.convertToArrayOfObj(account['shipToAddresses']);
        account['billToAddresses'] = this.convertToArrayOfObj(account['billToAddresses']);

        return Observable.of(account);
    }

    private edit(type: string, data: any) {
        let method;
        switch (type) {
            case 'address': method = this.accountService.editAddresses(data)
                break;
            case 'segments': method = this.accountService.editSegments(data)
                break;
            case 'main': method = this.accountService.editMain(data)
                break;
            case 'finance': method = this.accountService.editFinance(data)
                break;
            case 'sellerAccount': method = this.accountService.editSellerAccount(data)
                break;
            case 'catalog': method = this.accountService.editCatalog(data)
                break;
            case 'accountFeatures': method = this.accountService.editAccountFeatures(data)
                break;
        }
        method
            .subscribe(
                body => {
                    this.notificationService.success('Successfully edited the account', 'Success');
                    // this.refreshFrom.next(true);
                    // this.fetchItems();
                    this.router.navigate(['/agora/account-data/accounts/' + this.id + '/details']);
                },
                error => this.handleError(error)
            );
    }
    private onAddAddress(addForm: any) {

        this.detailsCommunication.id = null;
        this.detailsCommunication.domain = this.domain;
        this.communicationService.addCommunication(this.detailsCommunication)
            .subscribe(
                body => {
                    this.notificationService.success('Successfully added the address', 'Success');
                    this.addressess.push(this.detailsCommunication);
                    this.refresh.next(true);
                    addForm.resetForm();
                }
            );
    }
    private changeButtonIcon() {
        jQuery('#add').toggleClass('fa-caret-down');
        jQuery('#add').toggleClass('fa-caret-up');
    }
    private onChangeCountry(event) {
        if (event) {
            this.detailsCommunication.country = event;
            this.detailsCommunication.zipCode = undefined;
            this.pattern = this.getPatternByCountry(event);
            this.updateStates();
        }
    }
    private updateStates() {
        delete this.detailsCommunication.state;
        this.showStates = false;
        if (this.detailsCommunication.country) {
            this.communicationService.getStatesByCountry(this.detailsCommunication.country)
                .subscribe(
                    body => {
                        this.states = body.data;
                        if (this.states.length)
                            this.showStates = true;
                    },
                    err => {
                        this.states = [];
                    }
                );
        } else {
            this.states = [];
        }
    }
    private formatDict(obj: any) {
        this.codeCountryList = obj;
        let result = [];
        for (let prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                result.push({ key: prop, value: obj[prop] });
            }
        }
        return result;
    }
    private getPatternByCountry(country): string {
        for (let prop in this.codeCountryList) {
            if (this.codeCountryList.hasOwnProperty(prop)) {
                if (prop.indexOf(country) !== -1) {
                    return this.getPatternByCode(prop);
                }
            }
        }
    }
    private getPatternByCode(code): string {
        let pattern;
        for (let obj in this.patternList) {
            if (this.patternList[obj]['key'] == code) {
                pattern = this.patternList[obj]['pattern'];
                break;
            } else {
                pattern = '[nN]{1}\/[aA]{1}';
                continue;
            }
        }
        return pattern
    }
    // private onSaveSmt(event: any){
    //     let smtpDetails = {
    //         'label': this.smtpForm.controls.label.value,
    //         'isDefault': this.smtpForm.controls.isDefault.value,
    //         'host': this.smtpForm.controls.host.value,
    //         'username': this.smtpForm.controls.username.value,
    //         'password': this.smtpForm.controls.password.value,
    //         'port': this.smtpForm.controls.port.value,
    //         'email': this.smtpForm.controls.email.value
    //     };
    //     this.accountService.editSmtp(smtpDetails, this.id)
    //         .subscribe(
    //             body => {
    //                 this.notificationService.success('Successfully edited the SMTP details', 'Success');
    //                 this.refreshFrom.next(true);
    //             }
    //         )
    // }

    private fetchItems() {
        this.accountService.getAccountDetails(this.id)
            .bindToLifecycle(this)
            .subscribe(
                body => {
                    let details = <any>body['data'];
                    let accGroupsObj = {};
                    let accSegments = [];
                    let accAccreditations = [];
                    let accSellerSegments = [];
                    let accComputedSegments = [];
                    let shipToAddresses = [];
                    let billToAddresses = [];
                    if (details.accountGroups && details.accountGroups.length) {
                        details.accountGroups.forEach(ag => {
                            if (ag.configType === 'account-segments-type') {
                                accSegments.push(ag.id);
                            } else if (ag.configType === 'account-accreditations-type') {
                                accAccreditations.push(ag.id);
                            } else if (ag.configType === 'seller-managed-segments-type') {
                                accSellerSegments.push(ag.id);
                            } else if (ag.configType === 'computed-account-segments-type') {
                                accComputedSegments.push(ag.id);
                            }
                        });
                    }
                    if (details.shipToAddresses && details.shipToAddresses.length) {
                        details.shipToAddresses.forEach(addr => {
                            shipToAddresses.push(addr.id);
                        });
                    }
                    if (details.shipToAddresses && details.shipToAddresses.length) {
                        details.billToAddresses.forEach(addr => {
                            billToAddresses.push(addr.id);
                        });
                    }

                    this.adressesFields = this.accountService.getEditAddressesFields(details.domains[0].name);
                    details.accountSegments = accSegments;
                    details.accountAccreditations = accAccreditations;
                    details.accountSellerSegments = accSellerSegments;
                    details.accountComputedSegments = accComputedSegments;
                    details.shipToAddresses = shipToAddresses;
                    details.billToAddresses = billToAddresses;
                    this.details = details;
                    this.domain = details.domains[0].name;
                    this.getCreditInfo(details);
                }
            );
    }
    private onTabClick(e) {
        let tabId = e.srcElement.attributes['href'].value;
        this.router.navigate(
            ['/agora/account-data/accounts', this.id, 'edit'],
            { queryParams: { tab: tabId.substr(1) } }
        );
    }

    private handleError(error: any) {
        // this.notificationService.error(error, 'Failed');
    }
    onChangeCourseEventRetail(e){
        this.changeCourseEventRetailValue = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/edit/account-edit.component.ts